<template>
    <div>
        {{ display }}
    </div>
</template>

<script>
import { format } from "@/formatting/enumFormatter";

export default {
    types: [
        "enum"
    ],
    props: {
        value: {
            type: [ Number, String ],
            default: null,
        }
    },
    computed: {
        display(){
            // TODO: Consider we may want to render enums which are integers.
            return format(this.value);
        }
    }
};
</script>
